
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuotationRoutingModule } from './quotation.routing';
// tslint:disable no-import-side-effect
import '../styles/angular-material/theming.scss?global';
import '../styles/angular-material/simple-select.scss?global';
import '../styles/angular-material/text.scss?global';
import '../styles/angular-material/dialog.scss?global';
import '../styles/angular-material/mat-radio.scss?global';
import { QuotationQuotationsResourceModule } from 'libraries/service/resources/quotation-quotations/quotation-quotations-resource.module';
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { AfiMatDialogDefaultOptions } from "libraries/component/dialogs/afi-mat-dialog-default-options";

@NgModule({
    imports: [
        CommonModule,
        QuotationRoutingModule,
        QuotationQuotationsResourceModule,
    ],
    providers: [
        {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: new AfiMatDialogDefaultOptions()},
    ]
})
export class QuotationModule { }
